import { gql } from '@apollo/client';

const PAID_SERVICE_OPTION_FIELDS = gql`
  fragment PaidServiceOptionFields on PaidServiceOption {
    description
    discount
    id
    name
    price
  }
`;

const PAID_SERVICE_PAYMENT_METHODS_FIELDS = gql`
  fragment PaidServicePaymentMethodsFields on PaymentMethod {
    balance
    id
    name
  }
`;

const PAID_SERVICE_FIELDS = gql`
  ${PAID_SERVICE_OPTION_FIELDS}
  ${PAID_SERVICE_PAYMENT_METHODS_FIELDS}

  fragment PaidServiceFields on PaidService {
    description
    id
    options {
      ...PaidServiceOptionFields
    }
    paymentMethods {
      ...PaidServicePaymentMethodsFields
    }
    targetType
    title
  }
`;

export const VACANCY_FIELDS = gql`
  ${PAID_SERVICE_FIELDS}

  fragment vacancyFields on Vacancy {
    activationStatus
    ageFrom
    ageTo
    awaitingPayment
    bumpedAt
    categoryId
    createdAt
    daysLeft
    deletable
    description
    draft
    education
    educationId
    experience
    experienceId
    expirable
    hits
    id
    isBookmarked
    isBumped
    isFeatured
    isMine
    jobDescription
    location
    logo
    name
    paidServices {
      ...PaidServiceFields
    }
    positionName
    regionId
    rejectReason
    requirements
    responsibilities
    salaryFrom
    salaryTo
    status
    updatedAt
    email
    phones
    __typename
  }
`;

export const RESUME_FIELDS = gql`
  ${PAID_SERVICE_FIELDS}

  fragment resumeFields on Resume {
    id
    draft
    status
    activationStatus
    awaitingPayment
    bumpedAt
    createdAt
    updatedAt
    daysLeft
    expirable
    deletable
    isMine
    isBookmarked
    hits
    positionName
    name
    paidServices {
      ...PaidServiceFields
    }
    description
    personal
    skills
    salaryFrom
    salaryTo
    status
    __typename
    firstName
    surname
    patronymic
    email
    phones
    gender
    age
    dateOfBirth
    education
    educationId
    educationInfo
    experience
    experienceId
    experienceInfo
    regionId
    location
    categoryId
    logo
    rejectReason
    isBumped
    isFeatured
  }
`;

export const STATE_COUNTS_FIELDS = gql`
  fragment adsStateCounts on AdStateCounts {
    allCount
    publishedCount
    expiredCount
    pendingCount
    rejectedCount
    awaitingPaymentCount
  }
`;

export const COMPANY_FIELDS = gql`
  fragment companyFields on Company {
    contactName
    email
    id
    logoUrl
    name
    phones
    description
  }
`;

export const PAGE_INFO_FIELDS = gql`
  fragment pageInfoFields on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
`;
